import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./PersonalizedStats.css";

const searchLinks = {
  REVIEWS_LEFT: "/search?tab=reviewed&mmp-friendly=false&query=&offset=0&content=&wp-type=&tools=&ratings=&allergens=&categories=",
  RECIPES_SAVED: "/search?tab=saved&mmp-friendly=false&query=&offset=0&content=Recipe&wp-type=&tools=&ratings=&allergens=&categories=",
  RECIPES_MADE: "/search?tab=made&mmp-friendly=false&query=&offset=0&content=Recipe&wp-type=&tools=&ratings=&allergens=&categories=",
  RECIPES_LOVED: "/search?tab=loved&mmp-friendly=false&query=&offset=0&content=Recipe&wp-type=&tools=&ratings=&allergens=&categories=",
  MEAL_PLANS_SAVED: "/search?tab=saved&mmp-friendly=false&query=&offset=0&content=WizardPlan&wp-type=&tools=&ratings=&allergens=&categories=",
  MEAL_PLANS_MADE: "/search?tab=made&mmp-friendly=false&query=&offset=0&content=WizardPlan&wp-type=&tools=&ratings=&allergens=&categories=",
  MEAL_PLANS_LOVED: "/search?tab=loved&mmp-friendly=false&query=&offset=0&content=WizardPlan&wp-type=&tools=&ratings=&allergens=&categories=",
  MEAL_PLANS_CREATED: "/meal-plans/meal-planner",
};

export const PersonalizedStats = ({ stats }) => {
  const renderStat = (iconClassName, label, value, link) => (
    <li className="list-group-item p-1">
      {link ? (
        <Link className="personalized-stats-link" to={link}>
          <strong><i className={iconClassName} aria-hidden="true"></i> {label}:</strong> {value}
        </Link>
      ) : (
        <>
          <strong><i className={iconClassName} aria-hidden="true"></i> {label}:</strong> {value}
        </>
      )}
    </li>
  );

  const statRows = [
    ["fa-fw fa-solid fa-star text-primary", "Reviews left", stats?.reviewsLeft, searchLinks.REVIEWS_LEFT],
    ["fa-fw fa-solid fa-hat-chef text-primary", "Meal plans saved", stats?.mealPlansSaved, searchLinks.MEAL_PLANS_SAVED],
    ["fa-fw fa-solid fa-hat-chef text-primary", "Meal plans made", stats?.mealPlansMade, searchLinks.MEAL_PLANS_MADE],
    ["fa-fw fa-solid fa-hat-chef text-primary", "Meal plans loved", stats?.mealPlansLoved, searchLinks.MEAL_PLANS_LOVED],
    ["fa-fw fa-solid fa-fork-knife text-green", "Recipes saved", stats?.recipesSaved, searchLinks.RECIPES_SAVED],
    ["fa-fw fa-solid fa-fork-knife text-green", "Recipes made", stats?.recipesCompleted, searchLinks.RECIPES_MADE],
    ["fa-fw fa-solid fa-fork-knife text-green", "Recipes loved", stats?.recipesLoved, searchLinks.RECIPES_LOVED],
    ["fa-fw fa-solid fa-sparkles primary text-magic", "Meal plans created", stats?.mealPlansCreated, searchLinks.MEAL_PLANS_CREATED],
  ];

  return (stats &&
          <ul className="list-group list-group-flush">
            {statRows.map(([iconClassName, label, value, link]) => (
              <React.Fragment key={label}>
                {renderStat(iconClassName, label, value, link)}
              </React.Fragment>
            ))}
          </ul>
  );
};

PersonalizedStats.propTypes = {
  stats: PropTypes.shape({
    recipesSaved: PropTypes.number.isRequired,
    recipesLoved: PropTypes.number.isRequired,
    recipesCompleted: PropTypes.number.isRequired,
    mealPlansMade: PropTypes.number.isRequired,
    mealPlansCreated: PropTypes.number.isRequired,
    mealPlansSaved: PropTypes.number.isRequired,
    mealPlansLoved: PropTypes.number.isRequired,
    reviewsLeft: PropTypes.number.isRequired,
  }).isRequired,
};
